import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Task } from '../shared/task';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import DATA from './dev-collection.json';
import PROD_DATA from './prod-collection.json';
import { TaskRating } from './interfaces';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  collection: Task[] = [];
  constructor(private db: AngularFireDatabase) { }

  getCollections(): Observable<any> {
    return of(PROD_DATA);
    // if (environment.production) {
    //   // return this.db.object('/1An-XQNf96U7jHLEeWBtUUXRXe3auzKMRr4R8LXqggtc').valueChanges();
    //   return of(PROD_DATA);
    // } else {
    //   console.log('%c DEVELOPMENT ENVIRONMENT: Stored payload used', 'color: #bada55; font-size: medium');
    //   return of(DATA);
    // }
  }

  likeTask(task: number, user: string): void {
    const taskRating: TaskRating = {
      taskId: task,
      state: 'Like',
      uid: user,
    };
    this.db.object(`TaskRating/${user}/${task}`).set(taskRating);
  }

  dislikeTask(task: number, user: string): void {
    const taskRating: TaskRating = {
      taskId: task,
      state: 'Dislike',
      uid: user,
    };
    this.db.object(`TaskRating/${user}/${task}`).set(taskRating);
  }
}
